module.exports = __webpack_public_path__ + "static/img/noImg.ce18bf9.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/search/noImg.jpg
// module id = 283
// module chunks = 18